import { render, staticRenderFns } from "./df-page-product-by-code.vue?vue&type=template&id=7e3447aa"
import script from "./df-page-product-by-code.ts?vue&type=script&lang=js&external"
export * from "./df-page-product-by-code.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports